<template>
  <div class="add-user-modal">
    <span v-if="hasTitle" class="notify-title">{{ t('page.eventStatus.notifySetting') }}</span>
    <div class="list-select-table-wrap">
      <div class="select-list-wrap">
        <div class="select-list-header">{{ t('page.alarmGroup.alarmGroup') }}</div>
        <!--알림 주소록-->
        <c-scroll :style="hasTitle ? 'height: 237px' : 'height: 231px'">
          <ul class="select-list">
            <li
              v-for="(item, index) in addressBookItems"
              :key="index"
              :class="{ active: item.addressBookSq === selectedGroup.addressBookSq }"
            >
              <div class="select-item">
                <div
                  class="select-item-title ellipsis"
                  v-lego-tooltip:ellipsis="item.addressBookName + '(' + item.memberCount + ')'"
                  @click="onSelectGroup(item)"
                >
                  <span>{{ item.addressBookName }}</span>
                  <span> ({{ item.memberCount }})</span>
                </div>
                <lego-button
                  v-if="!item.selectDisable"
                  @click="addressBookSelect(item)"
                  style="
                    height: 24px;
                    min-width: 48px;
                    color: #2f3237;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 500;
                    border: 1px solid #d1d3d7;
                  "
                  >{{ t('button.add') }}
                </lego-button>
                <!--추가-->
              </div>
            </li>
          </ul>
        </c-scroll>
      </div>
      <div :class="{ 'table-wrap': true, 'small-size': isSmallSize }">
        <lego-paging-table
          ref="alarmUserSetting"
          multiSelect
          selectAll
          v-model="userSelected"
          :items="items"
          :headers="headers"
          :scrollMaxRow="hasTitle ? 7 : 6"
          :noSelectedShow="false"
          :selectActionControl="false"
          :isActionSelect="false"
          :selectMaxCnt="selectMaxItem"
          :messageMaxCnt="$t('page.eventStatus.notificationsTarget', { max: limitSelected })"
          @sort="onClickSort"
          @input="onClickRemoveAll"
          isNotScrollX
        >
          <template #extra-action>
            <scpm-filter-dialog
              ref="filterDialog"
              :schema="searchSchema"
              :model="searchModel"
              @reset="onReset"
              @searchField="onSearchField"
              @search="onSearch"
              :placeholder="$t('searchLabel.searchEqualMulti')"
            />
          </template>
        </lego-paging-table>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import i18nMixin from '@/mixins/i18n.mixin.js';
import validateFieldsMixin from '@/mixins/validateFields.mixin.js';
import { useAdditionalInfo } from '@/composables/addressBook/useAdditionalInfo.js';
import { mapGetters } from 'vuex';

const { getUserName } = useAdditionalInfo();

export default {
  mixins: [i18nMixin, validateFieldsMixin],
  emits: ['close:modal', 'user-selected', 'clickDeselection'],
  computed: {
    ...mapGetters('searchStore', { isResetFilterXss: 'getResetFilterXss' }),
    selected() {
      let addressBooks = this.$util.replaceArr(this.addressBookModel, {
        addressBookSq: 'seq',
        addressBookName: 'name',
        info: 'info',
        memberCount: 'count',
        userName: 'userName'
      });
      let users = this.$util.replaceArr(this.userSelected, {
        userName: 'name',
        email: 'info',
        userResourceId: 'seq'
      });
      addressBooks.forEach((item) => {
        item.addressBookName = item.name;
        item.type = 'ADDRBOOK';
      });
      users.forEach((item) => {
        item.type = 'USER';
      });
      let result = addressBooks.concat(users);
      return result;
    },
    searchParam() {
      let param = '?page=0&size=0&sort=' + this.sort.sortDataField + ':' + this.sort.sortOrder;
      return param;
    },
    selectMaxItem() {
      return this.limitSelected - this.selected.length + this.userSelected.length;
    }
  },
  props: {
    hasTitle: {
      type: Boolean,
      default: true
    },
    alarmInfos: {
      type: Array,
      default: () => {
        return [];
      }
    },
    itemsRemove: {
      type: Array,
      default: () => {
        return [];
      }
    },
    isSmallSize: {
      type: Boolean,
      default: false
    },
    openingPopupOther: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      allProjectMembers: [],
      items: [],
      itemsTemp: [],
      selectedGroup: {},
      addressBookItems: [],
      addressBookModel: [],
      userSelected: [],
      headers: [
        {
          text: this.$t('page.alarmGroup.userName'),
          value: 'userName',
          defaultValue: '-',
          sortable: true,
          minWidth: 100
        }, // 이름
        {
          text: this.$t('page.eventStatus.email'),
          value: 'email',
          defaultValue: '-',
          sortable: false,
          minWidth: 60
        } // 이메일
        // {
        //   text: this.$t('page.eventStatus.mobile'),
        //   value: 'mobile',
        //   width: 166,
        //   defaultValue: '-',
        //   sortable: true
        // }, // 휴대전화 //회사명
      ],
      page: {
        rowsPerPage: 3,
        currentPage: 1,
        totalPages: 1,
        totalItems: 0
      },
      diabledItems: [],
      rowMenuItems: '',
      sort: {
        sortDataField: 'user_name',
        sortOrder: 'asc'
      },
      chkUsers: [],
      limitSelected: 20,
      searchSchema: {
        fields: [
          {
            id: 'userName',
            model: 'userName',
            type: 'input',
            label: this.$t('page.alarmGroup.userName'), // IP 주소
            width: '100%',
            maxlength: 100,
            placeholder: this.$t('searchLabel.searchEqual', {
              VPC: this.$t('page.alarmGroup.userName')
            })
          },
          {
            id: 'email',
            model: 'email',
            type: 'input',
            label: this.$t('page.eventStatus.email'), // IP 주소
            width: '100%',
            maxlength: 100,
            placeholder: this.$t('searchLabel.searchEqual', {
              VPC: this.$t('page.alarmGroup.email')
            })
          }
          // {
          //   id: 'mobile',
          //   model: 'mobile',
          //   type: 'input',
          //   label: this.$t('page.eventStatus.mobile'), // IP 주소
          //   width: '100%',
          //   maxlength: 100
          // },
        ]
      },
      searchModel: {
        userName: '',
        email: ''
        // mobile: '',
      },
      validateFieldKey: 'addUser',
      selectedFilter: {}
    };
  },
  created() {
    this.getInitData();
  },

  methods: {
    async getData(searchParams) {
      const params = {
        ...searchParams,
        page: 0,
        size: 0,
        sort: `${this.sort.sortDataField || 'user_name'}:${this.sort.sortOrder || 'asc'}`
      };

      const url =
        this.selectedGroup.addressBookSq === 999999
          ? '/v1/console/address-books/accounts-members'
          : `/v1/console/address-books/${this.selectedGroup.addressBookSq}/address-book-users`;
      const data = await this.$http.system.get(url, params, true, false).catch((error) => {
        if (this.isResetFilterXss) {
          this.$refs.filterDialog?.onReset('error');
        }
        this.$alert(error, () => {
          this.items = [];
        });
      });

      if (!data) return;

      if (!data.contents.length) {
        this.items = [];
      } else {
        data.contents.forEach((item) => {
          item['userName'] = item.user_name;
          item['userResourceId'] = item.id;
        });
        this.items = data.contents;
      }
    },
    onClickRemoveAll(selected) {
      this.$emit('clickDeselection', selected);
    },
    onSearch() {
      if (this.$refs.alarmUserSetting) this.$refs.alarmUserSetting.$refs.table.clearErrorMessage();

      const params = {
        user_name: this.searchModel.userName,
        email: this.searchModel.email
      };
      this.selectedFilter = this.$util.deepCopy(params);
      this.getData(params);
    },
    onSearchField: _.debounce(function (field, value) {
      if (this.$refs.alarmUserSetting) this.$refs.alarmUserSetting.$refs.table.clearErrorMessage();

      if (field === 'userName') {
        field = 'user_name';
      }
      Object.keys(this.searchModel).forEach((key) => (this.searchModel[key] = ''));
      this.selectedFilter = { [field]: value };
      this.getData({ [field]: value });
    }, 100),
    onReset() {
      Object.keys(this.searchModel).forEach((key) => (this.searchModel[key] = ''));
      if (typeof this.$refs.alarmUserSetting != 'undefined') {
        this.$refs.alarmUserSetting.$refs.table.resetSort();
      }
      this.sort = {
        sortDataField: 'user_name',
        sortOrder: 'asc'
      };
      this.selectedFilter = {};
      this.userSelected = [];
      this.getData({});
    },

    // sortable
    onClickSort(sortItem) {
      this.sort.sortDataField = this.convertToSnakeCase(sortItem.value);
      this.sort.sortOrder = sortItem.asc ? 'asc' : 'desc';
      this.page.currentPage = 1;
      this.page.currentIndex = 0;
      this.getData(this.selectedFilter);
    },

    // 사용자 검색
    searchMembers(item, cmd) {
      this.items = [];
      this.itemsTemp = [];
      if (item.addressBookSq === 999999) {
        this.getProjectMembers();
      } else {
        this.getAddressBookMembers(item, cmd);
      }
    },

    // 프로젝트 멤버 목록
    getProjectMembers() {
      this.$http.system
        .get(`/v1/console/address-books/accounts-members` + this.searchParam)
        .then((data) => {
          //console.log('getProjectMembers data = ', data);
          if (data.contents) {
            data.contents.forEach((item) => {
              item['userName'] = item.user_name;
              item['userResourceId'] = item.id;
            });
            this.items = data.contents;
            this.itemsTemp = data.contents;
          }
        });
    },

    // 주소록 멤버 목록
    getAddressBookMembers(item, cmd) {
      this.$http.system
        .get(
          `/v1/console/address-books/${item.addressBookSq}/address-book-users` + this.searchParam
        )
        .then((data) => {
          const dataAddressBookMembers = data.contents.map((item) =>
            _.omit(item, ['addressBookSq'])
          );
          dataAddressBookMembers.forEach((item) => {
            item['userName'] = item.user_name;
            item['userResourceId'] = item.id;
          });
          this.items = dataAddressBookMembers;
          this.itemsTemp = dataAddressBookMembers;
          if (
            data.totalCount > 0 &&
            _.findIndex(this.addressBookModel, { addressBookSq: item.addressBookSq }) == -1
          ) {
            item.info = data.contents[0].userName || data.contents[0].user_name;
            if (data.totalCount > 1) {
              item.info +=
                this.$t('label.other') + (data.totalCount - 1) + this.$t('label.otherperson');
            }
            item.userName = data.contents[0].userName || data.contents[0].user_name;
            item.memberCount = data.totalCount;
            if (cmd == 'ADD') this.addressBookModel.push(item);
          }
        });
    },

    // 초기 데이타 셋팅
    getInitData() {
      let promiseArr = [];
      let param = '?page=0&size=0';
      let sorted = '';
      if (this.sort.sortDataField != null && this.sort.sortDataField.length > 0) {
        const order = this.sort.sortOrder ? `:${this.sort.sortOrder}` : '';
        sorted = `&sort=${this.sort.sortDataField}${order}`;
      }
      promiseArr.push(this.$http.system.get(`/v1/console/address-books` + param));
      promiseArr.push(
        this.$http.system.get(`/v1/console/address-books/accounts-members` + param + sorted)
      );

      Promise.all(promiseArr).then((data) => {
        //console.log('address-book Data = ', data);
        this.addressBookItems = data[0].contents.filter((v) => v.memberCount > 0);
        this.addressBookItems.unshift({
          addressBookName: this.t('page.eventStatus.defaultGroup'),
          memberCount: data[1].totalCount,
          selectDisable: true,
          addressBookSq: 999999
        });
        if (data[1].contents) {
          data[1].contents.forEach((item) => {
            item['userName'] = item.user_name;
            item['userResourceId'] = item.id;
          });
          this.allProjectMembers = [...data[1].contents];
          this.items = data[1].contents;
          this.itemsTemp = data[1].contents;
        }

        this.selectedGroup = this.addressBookItems[0];
        if (this.alarmInfos.length > 0) this.setNotifications(this.alarmInfos);
      });
    },
    setNotifications(alarmInfos, isFromTemplate = false) {
      this.addressBookModel = [];
      this.userSelected = [];
      if (!alarmInfos || !alarmInfos.length) return;
      alarmInfos.forEach((item) => {
        if (item.recipientType === 'ADDRBOOK') {
          let addressBook = {
            addressBookSq: parseInt(item.recipientKey),
            addressBookName: item.recipientName,
            info: this.nameCell(item),
            memberCount: item.addrbookAdditionalInfo.memberCount,
            userName: getUserName(item)
          };
          this.addressBookModel.push(addressBook);
        } else if (item.recipientType === 'USER') {
          if (isFromTemplate) {
            this.userSelected = this.allProjectMembers.filter((user) =>
              alarmInfos.find((e) => e.recipientKey == user.userResourceId)
            );
          } else {
            let user = _.find(this.items, { userResourceId: item.recipientKey });
            if (user) this.userSelected.push(user);
          }
        }
      });
    },

    nameCell(item) {
      let str = getUserName(item);
      if (item.addrbookAdditionalInfo.memberCount > 1) {
        str += ` 외 ${item.addrbookAdditionalInfo.memberCount - 1}명`;
      }
      return str;
    },

    addressBookSelect(item) {
      if (_.findIndex(this.addressBookModel, { addressBookSq: item.addressBookSq }) > -1) {
        window.app.$modal.open({
          rootId: 'app',
          type: 'alert',
          title: this.t('page.eventStatus.notice'),
          message: this.t('page.eventStatus.selectedAlarmGroup'),
          action: () => {}
        });
        return;
      }

      if (this.$refs.filterDialog) {
        Object.keys(this.searchModel).forEach((key) => (this.searchModel[key] = ''));
        this.$refs.filterDialog.setCountFilter();
        this.$refs.filterDialog.clearSearchField();
        this.selectedFilter = {};
      }

      if (this.selected.length >= this.limitSelected) {
        window.app.$modal.open({
          rootId: 'app',
          type: 'alert',
          title: this.t('page.eventStatus.notice'),
          message: this.$t('page.eventStatus.notificationsTarget', { max: this.limitSelected }),
          action: () => {}
        });
        return;
      }
      this.selectedGroup = item;
      this.searchMembers(item, 'ADD');
    },
    onSelectGroup(item) {
      this.$refs.alarmUserSetting.$refs.table.clearErrorMessage();

      if (this.$refs.filterDialog) {
        Object.keys(this.searchModel).forEach((key) => (this.searchModel[key] = ''));
        this.$refs.filterDialog.clearSearchField();
        this.$refs.filterDialog.setCountFilter();
        this.selectedFilter = {};
      }
      this.selectedGroup = item;
      this.searchMembers(item);
    },
    onConfirmClick() {
      this.$emit('user-selected', this.selected);
      this.modalClose();
    },
    deleteItem(items) {
      items.forEach((item) => {
        if (item.type === 'ADDRBOOK') {
          let itemIndex = _.findIndex(this.addressBookModel, { addressBookSq: item.seq });
          this.addressBookModel.splice(itemIndex, 1);
        } else {
          let itemIndex = _.findIndex(this.userSelected, { userResourceId: item.seq });
          this.userSelected.splice(itemIndex, 1);
        }
      });
    },
    modalClose() {
      this.$emit('close:modal');
    },
    convertToSnakeCase(str) {
      return str.replace(/([A-Z])/g, '_$1').toLowerCase();
    }
  },
  watch: {
    selected: {
      handler(v) {
        if (this.$refs.alarmUserSetting)
          this.$refs.alarmUserSetting.$refs.table.clearErrorMessage();
        this.$emit('user-selected', v);
      },
      deep: true
    },
    itemsRemove: {
      handler(v) {
        if (v.length === 0) return;
        this.deleteItem(v);
      },
      deep: true
    }
  },
  mounted() {
    this.headers[0].width = null;
  }
};
</script>

<style lang="scss">
.add-user-modal .simplebar-content {
  width: 100% !important;
}
</style>
<style lang="scss" scoped>
.add-user-modal {
  margin-bottom: 10px;
}

.notify-title {
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  padding-bottom: 12px;
  display: block;
}

.list-select-table-wrap {
  display: flex;
  align-items: normal;
  align-content: center;
  margin-top: 20px;

  .select-list-wrap {
    width: 300px;
    height: 295px;
    border: 1px solid #e4e5e7;
    border-radius: 4px;

    .select-list-header {
      height: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      font-weight: 700;
      color: var(--dark);
      background-color: var(--color-ui-12);
      border-top-left-radius: 4px;
      border-top-right-radius: 4px;
    }
  }

  .table-wrap {
    width: calc(1138px - 300px);
    padding-left: 16px;
  }

  .small-size {
    :deep(.lego-table) {
      .lego-table__counter {
        &:has(.message) {
          & ~ .lego-table__extra-action {
            .filter-dialog {
              .search-text {
                .lego-text-field {
                  width: 225px !important;
                }
              }
            }
          }
        }
      }
    }
  }
}

.select-list {
  & > li {
    height: 33px;
    padding: 5px 20px;
    font-size: 14px;
    font-weight: 500 !important;
    font-style: normal !important;
    color: #2f3237;
    cursor: pointer;

    .select-item {
      display: flex;
    }

    /* .select-item:hover {
        background-color: var(--color-primary-tint-01);
    } */

    em {
      padding-left: 6px;
      font-style: normal;
    }

    /* &.active {
        color: var(--blue-with-a-hint-of-purple);
        background-color: rgba(54, 79, 199, 0.12);
    } */
  }

  & > li:hover {
    color: var(--blue-with-a-hint-of-purple);
    background-color: var(--color-primary-tint-01);
  }
}

.select-item-title {
  width: 81%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 8px;
}

.batch-list-wrap {
  .total-header {
    padding: 20px 0 0 0;
  }

  .batch-list {
    min-height: 116px;
    margin: 8px 10px 0 0;
    padding: 8px 20px 20px;
    border-radius: 2px;
    border: solid 1px var(--color-ui-06);
    background-color: #fff;

    :deep .lego-chip__container {
      margin: 12px 10px 0 0 !important;
    }
  }
}

.active {
  color: #465dcb !important;
  background-color: var(--color-primary-tint-01);
}

:deep .left-divider:before {
  display: none !important;
}

:deep .lego-table__action-selected {
  position: relative;

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    display: block !important;
    width: 1px;
    height: 10px;
    background: #bbbdc1;
  }
}

:deep .left-divider .lego-table__counter__per-page {
  display: none !important;
}

.notify-title-control {
  display: flex;
  gap: 20px;
}
</style>
